import React, { useEffect } from "react";

// ----------------------------------------------------------------------
// SignupPage — soft-redirect to the walkthrough form on the marketing
// site. Public self-registration was disabled in V1 because ODRA's
// onboarding model is high-touch: founder visits the hotel, installs
// on-site, trains staff. Self-serve registration would generate junk
// accounts and bypass the controlled pilot flow.
//
// The /signup route is preserved (and renders this page) instead of
// being deleted outright so any stale bookmark, marketing link, or
// indexed search result still lands a prospect somewhere helpful.
// ----------------------------------------------------------------------

const WALKTHROUGH_URL = "https://odra.app/#walkthrough";

export default function SignupPage() {
  // Auto-redirect after a short pause so the visitor can read the
  // explanation if they want to (mirrors the "we don't self-serve;
  // here's how to get started" hospitality industry norm).
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = WALKTHROUGH_URL;
    }, 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="login-wrap">
      <div className="login-card" style={{ textAlign: "center" }}>
        <img
          src="/horizontal.svg?v=12"
          alt="ODRA"
          style={{
            display: "block",
            margin: "0 auto 18px",
            height: 90,
            maxWidth: "85%",
            objectFit: "contain",
          }}
        />

        <h2 style={{ margin: "0 0 8px", color: "var(--odra-navy)" }}>
          Welcome to ODRA
        </h2>

        <p className="muted" style={{ margin: "0 0 16px", lineHeight: 1.6 }}>
          We onboard hotels and restaurants <b>hands-on</b> — our team comes
          to your site to install, train your staff, and import your full menu.
          That means there's no self-serve signup here.
        </p>

        <p className="muted" style={{ margin: "0 0 24px", lineHeight: 1.6 }}>
          Request a 30-minute walkthrough and we'll discuss your operation,
          show you the platform live, and prepare a custom quote.
        </p>

        <a
          href={WALKTHROUGH_URL}
          className="btn"
          style={{
            display: "inline-block",
            padding: "12px 24px",
            fontSize: "1rem",
            textDecoration: "none",
          }}
        >
          Request a walkthrough →
        </a>

        <p className="muted" style={{ marginTop: 18, fontSize: "0.8rem" }}>
          Redirecting in a moment…
          <br />
          Already have credentials?{" "}
          <a href="/login" style={{ color: "var(--odra-teal)", fontWeight: 600 }}>
            Sign in here
          </a>
        </p>
      </div>
    </div>
  );
}
